import type { CSSProperties } from 'react';

import classnames from 'classnames';

import { DIVIDER_DEFAULTS } from './Divider.constants';
import * as styles from './Divider.css';
import type { DividerElementProps } from './Divider.types';

export function DividerElement(props: DividerElementProps) {
  const { element, children, className, attributes } = props;
  const {
    mobile_hide,
    desktop_hide,
    customAttributes,
    margin,
    backgroundColor,
    height,
    padding,
    borderRadius,
    mobileWidth,
    mobileMaxWidth,
    width,
    maxWidth,
  } = element.attrs || {};

  const [marginTop, marginRight, marginBottom, marginLeft] = (margin ?? DIVIDER_DEFAULTS.margin).toString().split(' ');

  return (
    <div
      {...customAttributes}
      className={classnames(
        className,
        {
          'mobile:hidden': mobile_hide,
          'desktop:hidden': desktop_hide,
        },
        styles.dividerElement,
        customAttributes?.className,
      )}
      style={
        {
          '--margin-top': marginTop,
          '--margin-right': marginRight,
          '--margin-bottom': marginBottom,
          '--margin-left': marginLeft,
          '--margin': margin ?? DIVIDER_DEFAULTS.margin,
          '--padding': padding ?? '12px 0px',
          '--background-color': backgroundColor,
          '--height': height ?? '1px',
          padding: padding,
          '--width': width,
          '--max-width': maxWidth,
          '--mobile-width': mobileWidth || '100%',
          '--mobile-max-width': mobileMaxWidth || '100%',
        } as CSSProperties
      }
      {...attributes}
    >
      <hr contentEditable={false} className={classnames(styles.hr)} style={{ borderRadius: borderRadius }} />

      {/* to get slate editor works */}
      {children}
    </div>
  );
}
